import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'translateHtml',
  standalone: true,
})
export class TranslateHtmlPipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  public transform(value: string): string {
    return this.translocoService.translate(value).replace(/\\n/g, '');
  }
}
